import React from "react";
import { Divider, Modal } from "antd";
import MaterialIcon from "material-icons-react";
import { useNavigate } from "react-router-dom";
import svg159 from '../assets/svg/svg159.svg'
import svg160 from '../assets/svg/svg160.svg'
import svg161 from '../assets/svg/svg161.svg'
import svg162 from '../assets/svg/svg162.svg'

const PaymentSuccessModal = ({
  isOpen,
  onClose,
  amount,
  transactionId,
  paymentMethod,
  date,
  purpose,
  currency = "Ksh",
  confirmationMessage = "Your service provider will send you a confirmation by SMS or email.",
  onDownloadReceipt,
  onReturnHome,
  showDownloadButton = true,
  showReturnButton = true,
  supportText = "Need help?",
  supportLink = "Contact our support team",
  onSupportClick,
  kplcToken,
  kplcUnits,
  kplcServiceRef,
  kplcCustomer,
  kplcAccount,
}) => {
  const navigate = useNavigate();

  const handleDownload = () => {
    if (onDownloadReceipt) {
      onDownloadReceipt();
    }
  };

  const handleReturn = () => {
    if (onReturnHome) {
      onReturnHome();
    }
    if (onClose) {
      onClose();
    }
  };

  const handleSupport = () => {
    if (onSupportClick) {
      onSupportClick();
    } else {
      // Navigate to contact page
      navigate('/', { state: { section: 'contact' } });
      if (onClose) {
        onClose();
      }
    }
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      width="27rem"
      closeIcon={null}
    >
      <div className="flex flex-col py-[1rem] "> 

        <div className="flex flex-col items-center text-center">
        <div className="w-[4rem] h-[4rem] rounded-full bg-[#D9F9E6] flex items-center justify-center">
         <img src={svg159} alt="svg159"/>
        </div>
 
     <div className="text-[#2F9461] text-[1.5rem] font-[400] leading-[2rem] font-lexendS mt-[1.37rem]">Payment Successful!</div>
 
        <div className="text-[#7A7493] font-lexendS text-[1rem] font-[400] leading-[1.625rem] text-center mt-[.77rem]   w-full">
          Your payment has been processed successfully. 
          You will receive a confirmation sms shortly.
        </div>
        </div>

     
        <div className="mt-[1.35rem] w-full bg-[#EDEDF1] rounded-[0.625rem] p-[1rem]"> 
          <div className="flex justify-between items-center ">
            <span className="text-[#4F4770] font-lexendS text-[1.125rem] font-[400] leading-[1.625rem]">
              Amount
            </span>
            <span className="text-[#4F4770] font-lexendS text-[1.125rem] font-[400] leading-[1.625rem]">
              {currency} {typeof amount === 'number' ? amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : amount}
            </span>
          </div>

          <Divider/>

          {/* Transaction ID */}
          {transactionId && (
            <div className="flex justify-between items-center mb-[1rem]">
              <span className="text-[#7A7493] font-lexendS text-[1rem] font-[400] leading-[1.625rem]">
                Transaction ID
              </span>

              <div className="rounded-lg border-[0.667px] border-black/10 py-[0.125rem] px-[.5rem]">
              <span className="text-[#000] font-lexendS text-[0.75rem] font-[400] leading-[1rem]">
                {transactionId}
              </span>
              </div>
            </div>
          )}

          {/* Payment Method */}
          {paymentMethod && (
            <div className="flex justify-between items-center mb-[1rem]">
              <span className="text-[#7A7493] font-lexendS text-[1rem] font-[400] leading-[1.625rem]">
                Payment Method
              </span>
              <span className="text-[#000] font-lexendS text-[1rem] font-[400] leading-[1.5rem]">
                {paymentMethod}
              </span>
            </div>
          )}

          {/* Date */}
          {date && (
            <div className="flex justify-between items-center mb-[1rem]">
              <span className="text-[#7A7493] font-lexendS text-[1rem] font-[400] leading-[1.625rem]">
                Date
              </span>
              <span className="text-[#000] font-lexendS text-[1rem] font-[400] leading-[1.5rem]">
                {date}
              </span>
            </div>
          )}

          {/* Purpose */}
          {purpose && (
            <div className="flex justify-between items-center">
              <span className="text-[#7A7493] font-lexendS text-[1rem] font-[400] leading-[1.625rem]">
                Purpose
              </span>
              <span className="text-[#000] font-lexendS text-[1rem] font-[400] leading-[1.5rem]">
                {purpose}
              </span>
            </div>
          )}
        </div>

        {/* KPLC Token Details */}
        {kplcToken && (
          <div className="mt-[1rem] w-full bg-[#F0FDF4] border border-[#BBF7D0] rounded-[0.625rem] p-[1rem]">
            <div className="text-[#2F9461] font-lexendS text-[0.75rem] font-[600] leading-[1rem] mb-[0.75rem] uppercase tracking-wide">
              KPLC Token Details
            </div>

            <div className="flex flex-col items-center mb-[0.75rem]">
              <span className="text-[#7A7493] font-lexendS text-[0.75rem] font-[400] leading-[1rem] mb-[0.25rem]">
                Token Number
              </span>
              <span className="text-[#0F172A] font-lexendS text-[1.25rem] font-[600] leading-[1.75rem] tracking-[0.15em]">
                {kplcToken}
              </span>
            </div>

            <div className="flex justify-between items-center mb-[0.5rem]">
              <span className="text-[#7A7493] font-lexendS text-[0.875rem] font-[400] leading-[1.25rem]">Units</span>
              <span className="text-[#0F172A] font-lexendS text-[0.875rem] font-[500] leading-[1.25rem]">{kplcUnits} kWh</span>
            </div>

            {kplcAccount && (
              <div className="flex justify-between items-center mb-[0.5rem]">
                <span className="text-[#7A7493] font-lexendS text-[0.875rem] font-[400] leading-[1.25rem]">Account</span>
                <span className="text-[#0F172A] font-lexendS text-[0.875rem] font-[500] leading-[1.25rem]">{kplcAccount}</span>
              </div>
            )}

            {kplcCustomer && (
              <div className="flex justify-between items-center mb-[0.5rem]">
                <span className="text-[#7A7493] font-lexendS text-[0.875rem] font-[400] leading-[1.25rem]">Customer</span>
                <span className="text-[#0F172A] font-lexendS text-[0.875rem] font-[500] leading-[1.25rem]">{kplcCustomer}</span>
              </div>
            )}

            {kplcServiceRef && (
              <div className="flex justify-between items-center">
                <span className="text-[#7A7493] font-lexendS text-[0.875rem] font-[400] leading-[1.25rem]">Service Ref</span>
                <span className="text-[#0F172A] font-lexendS text-[0.875rem] font-[500] leading-[1.25rem]">{kplcServiceRef}</span>
              </div>
            )}
          </div>
        )}
 
        {confirmationMessage && (
          <div className="flex items-center text-center justify-center mt-[2.61rem] gap-[0.75rem] w-full"> 
            
            <img src={svg160} alt="svg160"/>
            
            <div className="text-[#4F4770] lg:w-[17.0625rem] w-full font-lexendS text-[0.825rem] font-[400] leading-[1.25rem]">
              {confirmationMessage}
            </div> 
          </div>
        )}
 
        <div className="w-full flex flex-col gap-[0.75rem] mt-[1rem]">
          {showDownloadButton && (
            <button
              onClick={handleDownload}
              className="w-full bg-[#030213]  text-white font-lexendS text-[0.875rem] font-[500] rounded-[31.25rem]   flex items-center justify-center gap-[1rem] py-[.71rem]"
            >
              <img src={svg161} alt="svg161" />
              Download Receipt
            </button>
          )}

          {showReturnButton && (
            <button
              onClick={handleReturn}
              className="w-full bg-white  text-[#000] border border-[#E2E8F0] font-lexendS text-[0.875rem] font-[500] rounded-[31.25rem] py-[0.71rem] flex items-center justify-center gap-[1rem]"
            >
              <img src={svg162} alt="svg162"/>
              Return to Home
            </button>
          )}
        </div>

        {/* Support Link */}
        {(supportText || supportLink) && (
          <div className="mt-[2.5rem] flex items-center text-center justify-center gap-[0.25rem]">
            <span className="text-[#342F4D] font-lexendS text-[0.75rem] font-[400] leading-[1rem]">
              {supportText}
            </span>
            <button
              onClick={handleSupport}
              className="text-[#7A7493] font-lexendS text-[0.75rem] font-[400] leading-[1rem]"
            >
              {supportLink}
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default PaymentSuccessModal;
